import { EnvironmentVariables } from '../environment';

export const StripeConfig = {
    PublishableKey: EnvironmentVariables.STRIPE_PUBLIC_KEY,
};
